import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import RoundedAvatar from "../../RoundedAvatar";

const DefaultPhotoContainer = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  border-radius: 50%;
`;

const SmallPhotoContainer = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  border-radius: 50%;
`;

const Photo = props => {
  const { src, size, icon, name } = props;

  let sizeInPixels = 90;
  let Container = DefaultPhotoContainer;
  if (size === "small") {
    sizeInPixels = 45;
    Container = SmallPhotoContainer;
  }

  return (
    <Container {...props}>
      <RoundedAvatar
        imageSrc={src}
        icon={name ? null : icon}
        size={sizeInPixels}
      >
        {name}
      </RoundedAvatar>
    </Container>
  );
};

Photo.propTypes = {
  src: PropTypes.string,
  size: PropTypes.oneOf(["small", "normal"]),
  icon: PropTypes.string,
  name: PropTypes.string
};

Photo.defaultProps = {
  src: "",
  size: "normal",
  icon: "photoCamera",
  name: null
};

export default Photo;
